// extracted by mini-css-extract-plugin
export default {"container":"FullSizeGrid_container__e1r3l","grid":"FullSizeGrid_grid__p+5kF","image":"FullSizeGrid_image__zXNut","row":"FullSizeGrid_row__GQk5g"};